import { render } from "./TextModule.html?vue&type=template&id=84fbe39e&scoped=true&external"
import script from "./TextModule.vue?vue&type=script&lang=js"
export * from "./TextModule.vue?vue&type=script&lang=js"

import "./TextModule.vue?vue&type=style&index=0&id=84fbe39e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fbe39e"]])

export default __exports__